module.exports = __webpack_public_path__ + "static/media/loading.e36eee34.svg";